import { render } from "./CatalogOffer.vue?vue&type=template&id=5e093815&scoped=true"
import script from "./CatalogOffer.vue?vue&type=script&lang=js"
export * from "./CatalogOffer.vue?vue&type=script&lang=js"

import "./CatalogOffer.vue?vue&type=style&index=0&id=5e093815&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e093815"],['__file',"webpack-assets/vue/templates/product/catalog/parts/CatalogOffer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e093815"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e093815', __exports__)) {
    api.reload('5e093815', __exports__)
  }
  
  module.hot.accept("./CatalogOffer.vue?vue&type=template&id=5e093815&scoped=true", () => {
    api.rerender('5e093815', render)
  })

}


export default __exports__